<template>
  <!-- prettier-ignore -->
  <svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill-rule="nonzero" fill="none"><circle class="fill-blue-500" cx="12" cy="12" r="12"/><path d="M12 8a1.7 1.7 0 1 0 0-3.3A1.7 1.7 0 0 0 12 8Zm-1.3 2h2.6v9.3h-2.6V10Z" fill="#FFF"/></g></svg>
</template>
